module.exports = __webpack_public_path__ + "static/media/29BDOS24.3920f460.jpg";